module.exports = __webpack_public_path__ + "static/media/teilnahme_true_active.3dd60ae3.jpg";